import React, { useCallback, useEffect, useState } from "react";
import "error-polyfill";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./App.scss";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import GamePage from "./pages/GamePage";
import { IsMainnet, mainnetLaunchTime, NearConfig, useNear } from "./data/near";
import RulesPage from "./pages/RulesPage";
import Timer from "react-compound-timer";
import PreviousGamesPage from "./pages/PreviousGamesPage";
import { formatTimer } from "./data/utils";

function App(props) {
  const [connected, setConnected] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const [signedAccountId, setSignedAccountId] = useState(null);

  const _near = useNear();

  const requestSignIn = useCallback(
    async (e) => {
      e && e.preventDefault();
      const appTitle = "rekt.casino";
      const near = await _near;

      await near.walletConnection.requestSignIn(
        NearConfig.contractName,
        appTitle
      );
      return false;
    },
    [_near]
  );

  const logOut = useCallback(async () => {
    const near = await _near;
    near.walletConnection.signOut();
    near.accountId = null;
    setSignedIn(false);
    setSignedAccountId(null);
  }, [_near]);

  const refreshAllowance = useCallback(async () => {
    alert(
      "You're out of access key allowance. Need sign in again to refresh it"
    );
    await logOut();
    await requestSignIn();
  }, [logOut, requestSignIn]);

  useEffect(() => {
    _near.then((near) => {
      setSignedIn(!!near.accountId);
      setSignedAccountId(near.accountId);
      setConnected(true);
    });
  }, [_near]);

  const passProps = {
    refreshAllowance: () => refreshAllowance(),
    signedAccountId,
    signedIn,
    connected,
  };

  const header = !connected ? (
    <div>
      Connecting...{" "}
      <span
        className="spinner-grow spinner-grow-sm"
        role="status"
        aria-hidden="true"
      />
    </div>
  ) : signedIn ? (
    <div>
      <button className="btn btn-outline-light" onClick={() => logOut()}>
        Sign out ({signedAccountId})
      </button>
    </div>
  ) : (
    <div>
      <button
        className="btn btn-outline-light"
        onClick={(e) => requestSignIn(e)}
      >
        Sign in with NEAR Wallet
      </button>
    </div>
  );

  const timeUntilMainnet = mainnetLaunchTime - new Date().getTime();

  const skywardSale = (
    <>
      <div>
        5% of $REKT is sold on Skyward (5% referral program):{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://app.skyward.finance/sale/16"
        >
          https://app.skyward.finance/sale/16
        </a>
      </div>
      <div>
        $REKT is listed on REF finance (but not whitelisted):{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://app.ref.finance/pool/9"
        >
          https://app.ref.finance/pool/9
        </a>
      </div>
    </>
  );

  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
          <div className="container-fluid">
            <a
              className="navbar-brand"
              href="https://rekt.casino"
              title="rekt.casino"
            >
              rekt.casino
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" aria-current="page" to="/">
                    Game
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    aria-current="page"
                    to="/previous/"
                  >
                    Previous games
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" aria-current="page" to="/rules/">
                    Rules
                  </Link>
                </li>
              </ul>
              <form className="d-flex">{header}</form>
            </div>
          </div>
        </nav>
        {timeUntilMainnet > 0 ? (
          <div className="alert alert-info">
            Time until mainnet{" "}
            <Timer
              initialTime={timeUntilMainnet}
              direction="backward"
              timeToUpdate={1000}
              lastUnit="d"
            >
              {formatTimer}
            </Timer>
            {skywardSale}
          </div>
        ) : (
          <div className="alert alert-info">
            {!IsMainnet && (
              <div>
                Mainnet application at{" "}
                <a href="https://rekt.casino">rekt.casino</a>
              </div>
            )}
            {skywardSale}
          </div>
        )}

        <Switch>
          <Route exact path={"/"}>
            <GamePage {...passProps} />
          </Route>
          <Route exact path={"/previous/"}>
            <PreviousGamesPage {...passProps} />
          </Route>
          <Route exact path={"/rules/"}>
            <RulesPage {...passProps} />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
